import { ReactElement, useEffect, useState } from 'react'
import { AdminConfirmCancellationTemplate } from './adminconfirmcancellation.template'

import { useBFSM } from '../../contexts/bfsmContext'
import { useEndFlowManager } from '../../contexts/endFlowManagerContext'
import { ConfirmCancellationAdminState } from '@raskrask-dk/bookingflow-state-machine'
import { useAppSelector } from '../../redux/hooks'
import { getBookingId } from '../../redux/reducers/appSettings'
import { IPrivateBookingPaymentsDTO } from '@raskrask-dk/raskrask-utils'

const AdminConfirmCancellationPage = (): ReactElement => {
    const [BFSM] = useBFSM()
    const [EFM] = useEndFlowManager()

    const [bookingPayment, setBookingPayment] =
        useState<IPrivateBookingPaymentsDTO>()

    const bookingId = useAppSelector((state) => getBookingId(state))
    if (bookingId === undefined) throw new Error('bookingId is undefined')

    const onClickCTA = async () => {
        const {
            cancellationFeeSize,
            shouldSendCustomerMessages,
            shouldSendPartnerMessages,
            shouldCloseTime,
            cancelOnBehalfOf,
            cancelReason,
        } = BFSM.getData<ConfirmCancellationAdminState>()

        if (bookingId) {
            const res = await BFSM.repo.cancelBookingAdmin(
                bookingId,
                cancellationFeeSize > 0 ? true : false,
                cancellationFeeSize,
                shouldSendCustomerMessages,
                shouldSendPartnerMessages,
                shouldCloseTime,
                cancelOnBehalfOf,
                cancelReason
            )
            if (res === 'Success') {
                EFM.cancellation_chain.do()
            }
        }
    }

    useEffect(() => {
        const load = async () => {
            const bookingPaymnetInfo = await BFSM.repo.getInfoAboutPaidAmount(
                bookingId
            )
            setBookingPayment(bookingPaymnetInfo)
        }
        load()
    }, [])

    const templateProps = {
        canDoCta: true,
        onClickCta: onClickCTA,
        bookingId: bookingId,
        bookingPayment,
    }
    return <AdminConfirmCancellationTemplate {...templateProps} />
}
export default AdminConfirmCancellationPage
